class PromoCode extends HTMLElement {
  constructor() {
    super();
    this.data = this.parseData();
    this.codeEl = this.querySelector('[data-promo-code]');
    this.percentEl = this.querySelector('[data-promo-percentage]');
    this.copyBtn = this.querySelector('[data-promo-copy]');
    this.statusEl = this.querySelector('[data-promo-status]');
    this.strings = {
      copy: this.dataset.copyLabel || 'Copy code',
      copied: this.dataset.copiedLabel || 'Copied!',
      error: this.dataset.errorLabel || 'Copy failed — please copy it manually.',
    };
    this.onVariantUpdate = this.onVariantUpdate.bind(this);
    this.statusTimeout = null;
  }

  connectedCallback() {
    if (this.copyBtn) this.copyBtn.addEventListener('click', () => this.copy());
    document.addEventListener('venue:variant:updated', this.onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('venue:variant:updated', this.onVariantUpdate);
  }

  parseData() {
    const el = this.querySelector('[data-promo-map]');
    try {
      return JSON.parse(el?.textContent || '{}');
    } catch (err) {
      return {};
    }
  }

  onVariantUpdate(event) {
    const variant = event.detail?.variant;
    if (!variant) return;

    const promo = this.data[variant.id];
    const code = promo?.code;
    const percentage = promo?.percentage;
    const show = Boolean(code) && variant.available !== false;

    this.classList.toggle('hidden', !show);
    if (!show) return;

    if (this.codeEl) this.codeEl.textContent = code;
    if (this.percentEl && percentage != null && percentage !== '') {
      this.percentEl.textContent = `-${percentage}%`;
    }
    if (this.copyBtn) this.copyBtn.dataset.code = code;
    this.resetStatus();
  }

  async copy() {
    const code = this.copyBtn?.dataset.code || this.codeEl?.textContent?.trim();
    if (!code) return;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
      } else {
        this.fallbackCopy(code);
      }
      this.setStatus(this.strings.copied, 'is-copied');
    } catch (err) {
      this.setStatus(this.strings.error, 'is-error');
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    if (!ok) throw new Error('execCommand copy failed');
  }

  setStatus(message, modifier) {
    if (this.statusEl) {
      this.statusEl.textContent = message;
      this.statusEl.classList.remove('is-copied', 'is-error');
      if (modifier) this.statusEl.classList.add(modifier);
    }
    if (this.copyBtn) this.copyBtn.classList.toggle('is-copied', modifier === 'is-copied');

    clearTimeout(this.statusTimeout);
    this.statusTimeout = setTimeout(() => this.resetStatus(), 2500);
  }

  resetStatus() {
    clearTimeout(this.statusTimeout);
    if (this.statusEl) {
      this.statusEl.textContent = '';
      this.statusEl.classList.remove('is-copied', 'is-error');
    }
    if (this.copyBtn) this.copyBtn.classList.remove('is-copied');
  }
}

if (!customElements.get('promo-code')) {
  customElements.define('promo-code', PromoCode);
}
